import actions from './moduleProductFamilyActions.js';

export default {
  namespaced: true,
  actions: actions,
};
